export const portalHost = process.env.REACT_APP_PORTAL_HOST!
export const agentWebSocketUrl = process.env.REACT_APP_AGENT_WEBSOCKET_URL!
export const isLocalhost = process.env.REACT_APP_IS_LOCALHOST === 'true'

// Local overrides for site auth requirements (used when lookupSite isn't available locally)
export const localRequiresAuth =
  process.env.REACT_APP_REQUIRES_AUTH === 'true'
export const localRequiresMeshfa =
  process.env.REACT_APP_REQUIRES_MESHFA === 'true'
export const localEnableSpaceNotifications =
  process.env.REACT_APP_ENABLE_SPACE_NOTIFICATIONS === 'true'

export const agentRestUrl = process.env.REACT_APP_AGENT_REST_URL!

export const localhostSessionId = process.env.REACT_APP_LOCALHOST_SESSION_ID
export const localhostLinkKey = process.env.REACT_APP_LOCALHOST_LINK_KEY
